// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.media-viewer-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(0, 0, 0, 0.9);
    z-index: 1000;
    overflow: hidden;
}

.media-content-container {
    display: flex;
    width: 100%;
    height: 100%;
    position: relative;
    will-change: transform;
}

.media-content {
    flex-shrink: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.media-content img, .media-content video {
    max-width: 90%;
    max-height: 90%;
    -webkit-user-select: none;
            user-select: none; /* Prevent text selection or other artifacts during swipe */
    z-index: 1003;
}

.media-content img:hover, .media-content video:hover {
    opacity: 100%;
    -webkit-user-select: none;
            user-select: none;
}

.close-overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    border: none;
    color: white;
    background-color: transparent;
    font-size: 30px;
    cursor: pointer;
    z-index: 1002;
}

.close-button {
    position: absolute;
    top: 20px;
    right: 20px;
    width: 30px;
    height: 30px;
    border: none;
    color: white;
    background-color: transparent;
    font-size: 30px;
    cursor: pointer;
    z-index: 1001;
}

.close-button:hover {
    color: #f44336; /* Red shade on hover */
}`, "",{"version":3,"sources":["webpack://./src/MediaViewer.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,yBAAiB;YAAjB,iBAAiB,EAAE,2DAA2D;IAC9E,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,6BAA6B;IAC7B,eAAe;IACf,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,6BAA6B;IAC7B,eAAe;IACf,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,cAAc,EAAE,uBAAuB;AAC3C","sourcesContent":[".media-viewer-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    background: rgba(0, 0, 0, 0.9);\r\n    z-index: 1000;\r\n    overflow: hidden;\r\n}\r\n\r\n.media-content-container {\r\n    display: flex;\r\n    width: 100%;\r\n    height: 100%;\r\n    position: relative;\r\n    will-change: transform;\r\n}\r\n\r\n.media-content {\r\n    flex-shrink: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.media-content img, .media-content video {\r\n    max-width: 90%;\r\n    max-height: 90%;\r\n    user-select: none; /* Prevent text selection or other artifacts during swipe */\r\n    z-index: 1003;\r\n}\r\n\r\n.media-content img:hover, .media-content video:hover {\r\n    opacity: 100%;\r\n    user-select: none;\r\n}\r\n\r\n.close-overlay {\r\n    position: absolute;\r\n    width: 100%;\r\n    height: 100%;\r\n    border: none;\r\n    color: white;\r\n    background-color: transparent;\r\n    font-size: 30px;\r\n    cursor: pointer;\r\n    z-index: 1002;\r\n}\r\n\r\n.close-button {\r\n    position: absolute;\r\n    top: 20px;\r\n    right: 20px;\r\n    width: 30px;\r\n    height: 30px;\r\n    border: none;\r\n    color: white;\r\n    background-color: transparent;\r\n    font-size: 30px;\r\n    cursor: pointer;\r\n    z-index: 1001;\r\n}\r\n\r\n.close-button:hover {\r\n    color: #f44336; /* Red shade on hover */\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
